import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', href: '/', isRoute: true },
    { name: 'Chi Siamo', href: '#welcome', isRoute: false },
    { name: 'Prenota', href: '#prenota', isRoute: false },
    { name: 'Gallery', href: '/gallery', isRoute: true },
    { name: 'Senza Glutine', href: '#senza-glutine', isRoute: false },
    { name: 'Recensioni', href: '#recensioni', isRoute: false },
    { name: 'Lavora con Noi', href: '#lavora', isRoute: false },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg py-4'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_grano-v2/artifacts/rir9eg3m_LOGO-FOOTER-e1715783553327-1024x426.png"
              alt="Grano e Sale Logo"
              className={`w-auto transition-all duration-300 ${scrolled ? 'h-10' : 'h-14'}`}
              style={{ filter: scrolled ? 'none' : 'brightness(0) invert(1)' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className={`text-sm font-semibold uppercase tracking-wide transition-colors ${
                    scrolled
                      ? 'text-gray-700 hover:text-[#7f9e60]'
                      : 'text-white hover:text-gray-200'
                  }`}
                  style={{ textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.3)' }}
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className={`text-sm font-semibold uppercase tracking-wide transition-colors ${
                    scrolled
                      ? 'text-gray-700 hover:text-[#7f9e60]'
                      : 'text-white hover:text-gray-200'
                  }`}
                  style={{ textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.3)' }}
                >
                  {link.name}
                </a>
              )
            ))}
            <a
              href="tel:+393471674689"
              className={`flex items-center space-x-2 px-6 py-2.5 rounded-full font-semibold transition-all hover:scale-105 ${
                scrolled
                  ? 'bg-[#7f9e60] text-white hover:bg-[#6a8550]'
                  : 'bg-white text-[#7f9e60] hover:bg-gray-100'
              }`}
            >
              <Phone size={18} />
              <span>Chiama</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden transition-colors ${
              scrolled ? 'text-gray-800' : 'text-white'
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-6 bg-white rounded-xl shadow-2xl p-6 space-y-4">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className="block py-3 px-4 text-gray-700 font-semibold hover:bg-[#7f9e60]/10 hover:text-[#7f9e60] rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  className="block py-3 px-4 text-gray-700 font-semibold hover:bg-[#7f9e60]/10 hover:text-[#7f9e60] rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              )
            ))}
            <a
              href="tel:+393471674689"
              className="flex items-center justify-center space-x-2 py-3 px-4 bg-[#7f9e60] text-white font-semibold rounded-lg hover:bg-[#6a8550] transition-colors"
            >
              <Phone size={18} />
              <span>Chiama Ora</span>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;